module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_resort@3x-7d1febd76b414cce4731783a0a76cd3e.webp";